export default __webpack_public_path__ + "static/media/4.ESTIBA_DE_TREN.2f9189d5.jpg";